import React, { useState } from 'react';
import { Form, Input, Radio, Button, Card, Typography, DatePicker, Slider, Space, Steps } from 'antd';
import dayjs from 'dayjs';

const { Title, Text } = Typography;
const { Step } = Steps;

export default function GoalForm() {
  const [form] = Form.useForm();
  const [submittedData, setSubmittedData] = useState({});
  const [currentStep, setCurrentStep] = useState(0);

  const handleSubmit = (values) => {
    setSubmittedData({
      ...values,
      goals: values.goals.map((goal) => ({
        ...goal,
        targetDate: goal.targetDate.format('YYYY-MM-DD'),
      })),
    });
  };

  const steps = [
    {
      title: 'Info',
      content: (
        <>
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'Please enter your name' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Age"
            name="age"
            rules={[{ required: true, message: 'Please enter your age' }]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            label="Gender"
            name="gender"
            rules={[{ required: true, message: 'Please select your gender' }]}
          >
            <Radio.Group>
              <Radio value="male">Male</Radio>
              <Radio value="female">Female</Radio>
              <Radio value="other">Other</Radio>
            </Radio.Group>
          </Form.Item>
        </>
      ),
    },
    {
      title: 'Goals',
      content: (
        <Form.List name="goals">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                  <Form.Item
                    {...restField}
                    name={[name, 'title']}
                    rules={[{ required: true, message: 'Please enter the goal title' }]}
                  >
                    <Input placeholder="Goal Title" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'objective']}
                    rules={[{ required: true, message: 'Please select an objective' }]}
                  >
                    <Radio.Group>
                      <Radio value="retirement">Retirement</Radio>
                      <Radio value="education">Education</Radio>
                      <Radio value="investment">Investment</Radio>
                      {/* Add more options here as needed */}
                    </Radio.Group>
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'targetDate']}
                    rules={[{ required: true, message: 'Please select a target date' }]}
                  >
                    <DatePicker disabledDate={(current) => current && current < dayjs().endOf('day')} />
                  </Form.Item>
                  <Button type="danger" onClick={() => remove(name)}>
                    Remove
                  </Button>
                </Space>
              ))}
              <Form.Item>
                <Button type="dashed" onClick={() => add()} block>
                  Add Goal
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      ),
    },
    {
      title: 'Risk',
      content: (
        <>
          <Form.Item label="Risk Tolerance" name="riskTolerance">
            <Slider
              marks={{
                0: 'Low',
                50: 'Medium',
                100: 'High',
              }}
            />
          </Form.Item>
          {/* Add more risk-related fields here */}
        </>
      ),
    },
  ];

  return (
    <div>
      <Steps current={currentStep}>
        {steps.map((item) => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      <Form layout="vertical" form={form} onFinish={handleSubmit}>
        <div style={{ marginTop: '24px' }}>{steps[currentStep].content}</div>
        <div style={{ marginTop: '24px' }}>
          {currentStep > 0 && (
            <Button style={{ margin: '0 8px' }} onClick={() => setCurrentStep(currentStep - 1)}>
              Previous
            </Button>
          )}
          {currentStep < steps.length - 1 && (
            <Button type="primary" onClick={() => setCurrentStep(currentStep + 1)}>
              Next
            </Button>
          )}
          {currentStep === steps.length - 1 && (
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          )}
        </div>
      </Form>
      {submittedData.name && (
        <Card style={{ marginTop: '24px' }}>
          <Title level={4}>Submitted Data</Title>
          <Text>Name: {submittedData.name}</Text>
          <br />
          <Text>Age: {submittedData.age}</Text>
          <br />
          <Text>Gender: {submittedData.gender}</Text>
          <br />
          <Title level={5}>Goals</Title>
          {submittedData.goals.map((goal, index) => (
            <div key={index}>
              <Text>Title: {goal.title}</Text>
              <br />
              <Text>Objective: {goal.objective}</Text>
              <br />
              <Text>Target Date: {goal.targetDate}</Text>
              <br />
            </div>
          ))}
          <Text>Risk Tolerance: {submittedData.riskTolerance}</Text>
        </Card>
      )}
    </div>
  );
}